module.exports = __webpack_public_path__ + "0975afce9410f5b6b5b2c03bf86db06a.fbx";